const StimulatorMockData = [
    {
        id: 1,
        Rank: 1,
        MRO_name: "MRO Center A",
        Engine_id: "GE90-234",
        engine_type: "GE90",
        request_created_date: "07/01/2024",
        current_status: "Engine Overhaul",
        Priority: "75",
        Estimated_completion_date: "2024-07-08",
        Actual_completeion_Date: "2024-07-09",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 2,
        Rank: 2,
        MRO_name: "MRO Center A",
        Engine_id: "GE90-123",
        engine_type: "GE90",
        request_created_date: "06/15/2024",
        current_status: "In Maintenance",
        Priority: "90",
        Estimated_completion_date: "2024-06-23",
        Actual_completeion_Date: "2024-06-23",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 3,
        Rank: 3,
        MRO_name: "MRO Center A",
        Engine_id: "LEAP-112",
        engine_type: "LEAP",
        request_created_date: "05/03/2024",
        current_status: "Diagnostic Testing",
        Priority: "80",
        Estimated_completion_date: "2024-05-12",
        Actual_completeion_Date: "2024-05-13",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 4,
        Rank: 4,
        MRO_name: "MRO Center A",
        Engine_id: "GEnx-456",
        engine_type: "GEnx",
        request_created_date: "06/05/2024",
        current_status: "Pending Inspection",
        Priority: "88",
        Estimated_completion_date: "2024-06-14",
        Actual_completeion_Date: "2024-06-15",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 5,
        Rank: 5,
        MRO_name: "MRO Center A",
        Engine_id: "CFM56-789",
        engine_type: "CFM56",
        request_created_date: "07/04/2024",
        current_status: "Waiting for Parts",
        Priority: "95",
        Estimated_completion_date: "2024-07-08",
        Actual_completeion_Date: "2024-07-09",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 6,
        Rank: 1,
        MRO_name: "MRO Center B",
        Engine_id: "GACE90-2340",
        engine_type: "GEAC90",
        request_created_date: "05/16/2024",
        current_status: "Engine Overhaul",
        Priority: "90",
        Estimated_completion_date: "2024-05-27",
        Actual_completeion_Date: "2024-05-28",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 7,
        Rank: 2,
        MRO_name: "MRO Center B",
        Engine_id: "QWER-123",
        engine_type: "QWER",
        request_created_date: "06/25/2024",
        current_status: "In Maintenance",
        Priority: "85",
        Estimated_completion_date: "2024-06-29",
        Actual_completeion_Date: "2024-06-30",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 8,
        Rank: 3,
        MRO_name: "MRO Center B",
        Engine_id: "LEAP-112000",
        engine_type: "LEAP-0000",
        request_created_date: "06/08/2024",
        current_status: "Diagnostic Testing",
        Priority: "82",
        Estimated_completion_date: "2024-06-12",
        Actual_completeion_Date: "2024-06-13",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 9,
        Rank: 4,
        MRO_name: "MRO Center B",
        Engine_id: "GEnx-4560000",
        engine_type: "GEnxXX",
        request_created_date: "07/01/2024",
        current_status: "Pending Inspection",
        Priority: "80",
        Estimated_completion_date: "2024-07-10",
        Actual_completeion_Date: "2024-07-12",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 10,
        Rank: 5,
        MRO_name: "MRO Center B",
        Engine_id: "CAGL56-789",
        engine_type: "CFM56",
        request_created_date: "05/03/2024",
        current_status: "Waiting for Parts",
        Priority: "75",
        Estimated_completion_date: "2024-05-09",
        Actual_completeion_Date: "2024-05-10",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 11,
        Rank: 1,
        MRO_name: "MRO Center C",
        Engine_id: "GAC90-234",
        engine_type: "GAC90",
        request_created_date: "06/13/2024",
        current_status: "Engine Overhaul",
        Priority: "80",
        Estimated_completion_date: "2024-06-24",
        Actual_completeion_Date: "2024-06-28",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 12,
        Rank: 2,
        MRO_name: "MRO Center C",
        Engine_id: "GEC90-123",
        engine_type: "GECD90",
        request_created_date: "05/17/2024",
        current_status: "In Maintenance",
        Priority: "78",
        Estimated_completion_date: "2024-05-29",
        Actual_completeion_Date: "2024-05-30",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 13,
        Rank: 3,
        MRO_name: "MRO Center C",
        Engine_id: "LEAP-C-112",
        engine_type: "LEAP",
        request_created_date: "06/13/2024",
        current_status: "Diagnostic Testing",
        Priority: "90",
        Estimated_completion_date: "2024-06-23",
        Actual_completeion_Date: "2024-06-24",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 14,
        Rank: 4,
        MRO_name: "MRO Center C",
        Engine_id: "GEnx-C-456",
        engine_type: "GEnx",
        request_created_date: "07/02/2024",
        current_status: "Pending Inspection",
        Priority: "83",
        Estimated_completion_date: "2024-07-05",
        Actual_completeion_Date: "2024-07-06",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 15,
        Rank: 5,
        MRO_name: "MRO Center C",
        Engine_id: "CFM56-C-789",
        engine_type: "CFM56",
        request_created_date: "07/02/2024",
        current_status: "Waiting for Parts",
        Priority: "92",
        Estimated_completion_date: "2024-07-08",
        Actual_completeion_Date: "2024-07-10",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 16,
        Rank: 1,
        MRO_name: "MRO Center D",
        Engine_id: "GE90-C-234",
        engine_type: "GE90",
        request_created_date: "05/18/2024",
        current_status: "Engine Overhaul",
        Priority: "92",
        Estimated_completion_date: "2024-05-25",
        Actual_completeion_Date: "2024-05-28",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 17,
        Rank: 2,
        MRO_name: "MRO Center D",
        Engine_id: "GE90-C-123",
        engine_type: "GE90",
        request_created_date: "06/21/2024",
        current_status: "In Maintenance",
        Priority: "75",
        Estimated_completion_date: "2024-06-28",
        Actual_completeion_Date: "2024-06-30",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 18,
        Rank: 3,
        MRO_name: "MRO Center D",
        Engine_id: "LEAP-CD-112",
        engine_type: "LEAP",
        request_created_date: "05/02/2024",
        current_status: "Engine Overhaul",
        Priority: "80",
        Estimated_completion_date: "2024-06-08",
        Actual_completeion_Date: "2024-06-09",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 19,
        Rank: 4,
        MRO_name: "MRO Center D",
        Engine_id: "GEnx-CD456",
        engine_type: "GEnx",
        request_created_date: "05/15/2024",
        current_status: "Pending Inspection",
        Priority: "88",
        Estimated_completion_date: "2024-05-24",
        Actual_completeion_Date: "2024-05-25",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 20,
        Rank: 5,
        MRO_name: "MRO Center D",
        Engine_id: "CFM56-CD-789",
        engine_type: "CFM56",
        request_created_date: "06/10/2024",
        current_status: "Engine Overhaul",
        Priority: "95",
        Estimated_completion_date: "2024-06-23",
        Actual_completeion_Date: "2024-06-25",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 21,
        Rank: 1,
        MRO_name: "MRO Center E",
        Engine_id: "GE90-CDE-234",
        engine_type: "GE90",
        request_created_date: "06/28/2024",
        current_status: "Engine Overhaul",
        Priority: "90",
        Estimated_completion_date: "2024-07-07",
        Actual_completeion_Date: "2024-07-08",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 22,
        Rank: 2,
        MRO_name: "MRO Center E",
        Engine_id: "GE90-CDE-3123",
        engine_type: "GE90",
        request_created_date: "06/10/2024",
        current_status: "Engine Overhaul",
        Priority: "95",
        Estimated_completion_date: "2024-06-30",
        Actual_completeion_Date: "2024-06-27",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 23,
        Rank: 3,
        MRO_name: "MRO Center E",
        Engine_id: "LEAP-CDE-112",
        engine_type: "LEAP",
        request_created_date: "05/03/2024",
        current_status: "Diagnostic Testing",
        Priority: "87",
        Estimated_completion_date: "2024-05-13",
        Actual_completeion_Date: "2024-05-12",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 24,
        Rank: 4,
        MRO_name: "MRO Center E",
        Engine_id: "GEnx-CDE-456",
        engine_type: "GEnx",
        request_created_date: "06/20/2024",
        current_status: "Pending Inspection",
        Priority: "88",
        Estimated_completion_date: "2024-06-25",
        Actual_completeion_Date: "2024-06-24",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 25,
        Rank: 5,
        MRO_name: "MRO Center E",
        Engine_id: "CFM56-CDE-789",
        engine_type: "CFM56",
        request_created_date: "07/01/2024",
        current_status: "Waiting for Parts",
        Priority: "76",
        Estimated_completion_date: "2024-07-15",
        Actual_completeion_Date: "2024-07-12",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    },
    {
        id: 26,
        Rank: 5,
        MRO_name: "MRO Center B",
        Engine_id: "CFM56-CDE-78445656544439",
        engine_type: "CFM56",
        request_created_date: "07/01/2024",
        current_status: "Waiting for Parts",
        Priority: "65",
        Estimated_completion_date: "2024-07-15",
        Actual_completeion_Date: "2024-07-12",
        no_of_days_taken: 15,
        created_by: "jamwant.yadav@affine.ai"
    }
];

export default StimulatorMockData;
